// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"57106f50","186":"8145d35f","235":"c495c506","372":"71ac55d9","777":"248187e3"}[chunkId] + ".css";
};